export default __webpack_public_path__ + "img/5f277fee791b24efcc4f2f605d5a73af.png";